import React from 'react';
import { Row, Col } from 'antd';

import BillingInfo from './BillingInfo';
import SupervisorInfo from './SupervisorInfo';
import PrimaryContactInfo from './PrimaryContactInfo';
import TimesheetApproverInfo from './TimesheetApproverInfo';
import { ProfileCorporateInfoModel } from 'api/backofficeApiClient';

type Props = {
  corporateInfo?: ProfileCorporateInfoModel;
};

export default function AdditionalInfo(props: Props) {
  const { corporateInfo } = props;

  return (
    <Row gutter={[10, 10]}>
      <Col xs={24} md={12} className="d-flex">
        <BillingInfo corporateInfo={corporateInfo} />
      </Col>

      <Col xs={24} md={12} className="d-flex">
        <PrimaryContactInfo corporateInfo={corporateInfo} />
      </Col>

      <Col xs={24} md={12} className="d-flex">
        <SupervisorInfo corporateInfo={corporateInfo} />
      </Col>

      <Col xs={24} md={12} className="d-flex">
        <TimesheetApproverInfo corporateInfo={corporateInfo} />
      </Col>
    </Row>
  );
}
